import { render, staticRenderFns } from "./SRButton.vue?vue&type=template&id=227c0922&"
import script from "./SRButton.vue?vue&type=script&lang=js&"
export * from "./SRButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports